export default "__VITE_ASSET__JAXiN$G0__"